<template>
	<div class="m-progress">
		<ul>
            <li v-for="item in valuationArr" :key="item.name" class="f-tc">
                <div>
                    <span :style="{width: item.value}" :class="{'low-length': item.color === 0, 'middle-length': item.color === 1, 'high-length': item.color === 2}"></span>
                </div>
                <span class="text" :class="{'low-text': item.text === 0, 'middle-text': item.text === 1, 'high-text': item.text === 2}">{{item.name}}</span>
            </li>
        </ul>
	</div>
</template>

<script>
    export default {
        name: "progress",
        props: {
            rate: {
                type: Number
            }
        },
        watch: {
            rate(newData){
                console.log(1, newData);
                if (newData === '' || newData === null || newData === undefined) {
                    return;
                }
                let value = 100 - newData;
                this.watchData(value);
            }
        },
        data () {
            return {
                valuationArr: [{
                    name: '较低',
                    value: 0,
                    text: -1,
                    color: -1,
                }, {
                    name: '适中',
                    value: 0,
                    text: -1,
                    color: -1,
                }, {
                    name: '较高',
                    value: 0,
                    text: -1,
                    color: -1,
                }]
			}
        },
        methods: {
            watchData(value) {
                let obj0 = {}, obj1 = {}, obj2 = {};
                this.valuationArr = [];
                if (value <= 30) {
                    obj0 = {
                        name: '较低',
                        value: `${((value / 30) * 100).toFixed(2)}%`,
                        text: 0,
                        color: 0,
                    },
                    obj1 = {
                        name: '适中',
                        value: 0,
                        text: -1,
                        color: -1,
                    }
                    obj2 = {
                        name: '较高',
                        value: 0,
                        text: -1,
                        color: -1,
                    }
                } else if (value > 30 && value <= 70) {
                    obj0 = {
                        name: '较低',
                        value: '100%',
                        text: -1,
                        color: 0,
                    }
                    obj1 = {
                        name: '适中',
                        value: `${(((value - 30) / 40) * 100).toFixed(2)}%`,
                        text: 1,
                        color: 1,
                    }
                    obj2 = {
                        name: '较高',
                        value: 0,
                        text: -1,
                        color: -1,
                    }
                } else if(value > 70 && value <= 100){
                    obj0 = {
                        name: '较低',
                        value: '100%',
                        text: -1,
                        color: 0,
                    }
                    obj1 = {
                        name: '适中',
                        value: '100%',
                        text: -1,
                        color: 1,
                    }
                    obj2 = {
                        name: '较高',
                        value: `${(((value - 70) / 30) * 100).toFixed(2)}%`,
                        text: 2,
                        color: 2,
                    }
                }
                this.valuationArr.push(obj0, obj1, obj2);
            }
        },
        mounted() {
            console.log(2, this.rate);
            if (this.rate === '' || this.rate === null || this.rate === undefined) {
                return;
            }
            let value = 100 - this.rate;
            this.watchData(value);
        }
    }
</script>

<style lang="less">
.m-progress {
    width: 100%;
    ul {
        li {
            display: inline-block;
            div {
                position: relative;
                width: 200px;
                height: 16px;
                background-color: #F6F6F6;
                margin-bottom: 16px;
                span {
                    position: absolute;
                    top: 0;
                    left: 0;
                    height: 100%;
                }
            }
            
            .text {
                font-family: PingFangSC-Medium;
                font-size: 24px;
                line-height: 32px;
                font-weight: 400;
                color: #999999;
            }
            .low-text {
                color: #00BB1D;
            }
            .middle-text {
                color: #FAA500;
            }
            .high-text {
                color:  #FF330A;
            }
            .low-length {
                background-image: linear-gradient(270deg, #00CC22 0%, #2EE64D 100%);
            }
            .middle-length {
                background-image: linear-gradient(270deg, #FF8000 0%, #FFAA00 100%);
            }
            .high-length {
                background-image: linear-gradient(270deg, #FF330A 0%, #FF8000 100%);
            }
            &:first-child div,  &:first-child div span {
                border-radius: 8px 0 0 8px;
            }
            &:last-child div,  &:last-child div span {
                border-radius: 0 8px 8px 0;
            }
            &:nth-child(2) {
                margin: 0 16px;
            }
        }
    }
}
</style>
